import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteService } from 'src/app/services/delete.service';
import { AlunoFinanceiroService } from 'src/app/services/aluno/aluno-financeiro.service';
import { FormService } from 'src/app/services/form.service';
import { AnimationsService } from 'src/app/services/animations.service';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AlunoStoreSelectors, AlunoStoreState } from 'src/app/_store/aluno-store';
import { AuthService } from 'src/app/security/auth.service';
import { AlunoFinanceiroContratoComponent } from 'src/app/views/alunos/matricula-aluno/aluno-financeiro-contrato/aluno-financeiro-contrato.component'
import { EventEmitterService } from 'src/app/services/EventEmitterService';
import { MsgCompraComponent } from '../msg-compra/msg-compra.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { API } from 'src/app/services/api';
import { environment } from 'src/environments/environment';
import { catchError, map, tap } from 'rxjs/operators';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';

interface DtoPagamentos{
  pagamenId: number
  codigoBarras: string
  codigoPix: string
}

interface DtoCobrancaPagamento {
  matriculaId: number
  usuarioId: number
  email: string
  celular: string
  valorTotal: number
  pagamentoIds: any[]
  pagamentos: DtoPagamentos
  tipoPagamento: number
}

export const CompareTodosValores = (field1Control: string, valor: number): any => {
  return (formGroup: FormGroup) => {
    const field1: FormArray = formGroup.controls[field1Control] as FormArray;
    let valorInserido: number = 0;
    field1.value.forEach(elem => valorInserido += elem?.valor);
    if (valorInserido > valor) {
      field1.controls.forEach((elem: FormGroup) => elem?.controls['valor'].setErrors({ bigValue: true })); // Set error
    }
  };
}

@Component({
  selector: 'app-pgto-cc',
  templateUrl: './pgto-cc.component.html',
  styleUrls: ['./pgto-cc.component.scss']
})
export class PgtoCcComponent implements OnInit, OnDestroy {
  @ViewChild('inputElement', { static: false }) inputElement: ElementRef<HTMLInputElement>;
  form: FormGroup = null;
  cartoes: FormArray;
  valorTotal: number;
  opcoesParcelamento: number[] = [];
  efetuandoPagamento: boolean = false;

  meses = [
    { value: 1, label: '01' }, { value: 2, label: '02' }, { value: 3, label: '03' },
    { value: 4, label: '04' }, { value: 5, label: '05' }, { value: 6, label: '06' },
    { value: 7, label: '07' }, { value: 8, label: '08' }, { value: 9, label: '09' },
    { value: 10, label: '10' }, { value: 11, label: '11' }, { value: 12, label: '12' }
  ];
  anosValidade: number[] = Array.from({ length: 11 }, (_, i) => new Date().getFullYear() + i);
  matricula$: Subscription;
  matriculaId: number = null;
  pagamentos: any[] = [];
  tipoPagamento: number = null;
  alunoFinanceiroContratoComponent: AlunoFinanceiroContratoComponent;
  token: string = null;  
  valor: number = 0;
  cobranca: any = null;
  usuarioId: number;
  pagamentoIds: any[] = [];
  selectedPayment: number;
  tipoCartao: boolean = true;
  tipoBoleto: boolean = false;
  tipoPix: boolean = false;
  codigoPagamento: any[] = [];
  codigoLinha: boolean = false;
  objCartao: boolean;
  tipoPgto: string;
  isMobileScreen: boolean;

  constructor(
    public dialogRef: MatDialogRef<PgtoCcComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private deleteService: DeleteService,
    private alunoFinanceiroService: AlunoFinanceiroService,
    private formService: FormService,
    private animationsService: AnimationsService,
    private dialog: MatDialog,
    private storeAluno: Store<AlunoStoreState.Aluno>,
    private authService: AuthService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    //Acessando o parâmetro "matriculaId"
    this.route.queryParams.subscribe(params => {
        this.token = params['token'];
    });

    this.loadData();
  }

  ngOnDestroy(): void {
    if(this.matricula$) this.matricula$.unsubscribe();
  }

  async loadData(): Promise<void> {
    //await this.getMatricula();
   await this.obterCobranca();
    ;
    // alert(this.cobranca.valorTotal);
    // this.valorTotal = this.cobranca.valorTotal;


    // if(this.data?.solicitacao) {
    //   this.valorTotal = this.data?.solicitacao?.valor;
    //   this.opcoesParcelamento = Array(12).fill('').map((x,i) => i+1);
    // } else {
    //   this.valorTotal = (this.data?.pendencia?.valor) ? this.data.pendencia.valor : this.calcularValorTotal(this.data?.pagamento, this.data?.campanha);
    //   this.opcoesParcelamento = this.validarOpcoesParcelamento(this.valorTotal);
    // }
    this.buildForm();
    this.addCartoes(this.valorTotal);
  }

  buildForm(): void {
    this.form = this.fb.group({
      cartoes: this.fb.array([])
    });

    this.form.setValidators([CompareTodosValores('cartoes', this.valorTotal)]);
    this.cartoes = this.form.get('cartoes') as FormArray;
  }

  calcularValorTotal(pagamento: any, campanha: any): number {
    if(!pagamento) return 0;
    if(!campanha) campanha = {};
    const { valorTaxaMatricula, valorTotalInscricaoProva, valorTotalPlano, valorMaterialDidatico } = pagamento;
    const { descontoPlanoPagamento, descontoTaxaInscricaoProvas, descontoTaxaMatricula, descontoTaxaMateriaDidatico } = campanha;

    let valor: number = 0;
    if(valorTotalPlano)           descontoPlanoPagamento      ? (valor += (valorTotalPlano          - (valorTotalPlano          * (descontoPlanoPagamento      / 100)))) : (valor += valorTotalPlano);
    if(valorTaxaMatricula)        descontoTaxaMatricula       ? (valor += (valorTaxaMatricula       - (valorTaxaMatricula       * (descontoTaxaMatricula       / 100)))) : (valor += valorTaxaMatricula);
    if(valorTotalInscricaoProva)  descontoTaxaInscricaoProvas ? (valor += (valorTotalInscricaoProva - (valorTotalInscricaoProva * (descontoTaxaInscricaoProvas / 100)))) : (valor += valorTotalInscricaoProva);
    if(this.data?.incluirApostila && valorMaterialDidatico)     descontoTaxaMateriaDidatico ? (valor += (valorMaterialDidatico    - (valorMaterialDidatico    * (descontoTaxaMateriaDidatico / 100)))) : (valor += valorMaterialDidatico);

    return valor;
  }

  validarOpcoesParcelamento(valor: number): number[] {
    if(valor <= 180) return Array(1).fill('').map((x,i) => i+1);
    else if((valor>180) && (valor<=360)) return Array(2).fill('').map((x,i) => i+1);
    else if((valor>360) && (valor<=540)) return Array(4).fill('').map((x,i) => i+1);
    else if((valor>540) && (valor<=700)) return Array(5).fill('').map((x,i) => i+1);
    else if((valor>700) && (valor<=880)) return Array(6).fill('').map((x,i) => i+1);
    else return Array(12).fill('').map((x,i) => i+1);
  }

  addCartoes(valor:number = null): void {
    this.cartoes.push(
      this.fb.group({
        valor: [{disabled: true, value: valor}, [Validators.required]],
        parcela: [1, [Validators.required]],
        numero: [null, [Validators.required]],
        nome: [null, [Validators.required]],
        mes: [null, [Validators.required]],
        ano: [null, [Validators.required]],
        codigo: [null, [Validators.required]],
        informarCpfTitular: [false],
        cpfTitular: [null]
      })
    );
  }

  getCardData(index: number): any {
    const val = (this.form.get('cartoes') as FormArray).at(index).value;
    return {
      ...val,
      validade: val.mes && val.ano ? `${val.mes.toString().padStart(2, '0')}/${val.ano}` : null
    };
  }

  removeDoFormArray(controls: any, index: number) {
    this.deleteService.openDelete().then(res => {
      if (!res) return;
      controls as FormArray;
      controls.removeAt(index);
    });
  }

  getFormArray(index: number): any {
    const formArray: FormArray = this.form.get('cartoes') as FormArray;
    return formArray.at(index).value;
  }

  hasError(index: number, error: string): boolean {
    const formArray: FormArray = this.form.get('cartoes') as FormArray;
    return formArray.at(index).get('valor').hasError(error);
  }

  efetuarPagamentoCartaoCredito(): void {
    ;
    // Validating form
    this.formService.validateAllFields(this.form);
    if (!this.form.valid) {
      this.animationsService.showErrorSnackBar('Preencha todos os campos obrigatórios');
      return;
    }
    const formArray: FormArray = this.form.get('cartoes') as FormArray;
    const formGroup: FormGroup = formArray.at(0) as FormGroup;
    const { valor, parcela, numero, nome, mes, ano, codigo, informarCpfTitular, cpfTitular } = formGroup.getRawValue();

    const usuario = this.authService.getToken();
    const data = {
      usuarioLogadoId: this.usuarioId,
      matriculaId: this.matriculaId,
      quantidadeParcela: parcela,
      valorTotal: parseFloat(valor.replace(/\./g, '').replace(',', '.')),
      dadosCartaoAluno: {
        id: 0,
        numeroCartao: numero,
        nomePessoa: nome,
        mesValidade: ((mes || 1) - 1).toString(), // 0-indexed (backend faz +1)
        anoValidade: (ano || '').toString(),
        codigoSeguranca: codigo
      },
      // RF-09: CPF do titular do cartão
      cpfTitularCartao: informarCpfTitular && cpfTitular
        ? cpfTitular.replace(/\D/g, '') : null,
      pagamentoIds: this.pagamentos.map(pagamento => pagamento.pagamenId)
    }

    // if(this.data?.solicitacao) data['solicitacaoId'] = this.data?.solicitacao?.id;
    // else data['pagamentoIds'] = this.data?.pendencia?.pagamentoIds;

    this.efetuandoPagamento = true;
    this.alunoFinanceiroService.efetuarPagamentoCartaoCredito(data).subscribe(val => {
      this.efetuandoPagamento = false;
      if (val?.status === 'error') return;
      else if(val?.retornoCartao === 2 )  this.openMsg(false, 'Transação não autorizada. Entre em contato com seu banco emissor ou por favor tente outro cartão.');
      else if(val?.retornoCartao === 3 )  this.openMsg(false, 'Cartão expirado.');
      else if(val?.retornoCartao === 4 )  this.openMsg(false, 'Cartão bloqueado.');
      else if(val?.retornoCartao === 5 )  this.openMsg(false, 'Contate administradora do cartão.');
      else if(val?.retornoCartao === 6 )  this.openMsg(false, 'Cartão cancelado.');
      else if(val?.retornoCartao === 7 )  this.openMsg(false, 'Verificar os dados digitados. Tente outro cartão ou entre em contato com seu banco emissor.');
      else if(val?.retornoCartao === 8 )  this.openMsg(false, 'Transação já confirmada.');
      else if(val?.retornoCartao === 9 )  this.openMsg(false, 'Limite excedido, tente outro meio de pagamento.');
      else if(val?.retornoCartao === 10 ) this.openMsg(false, 'Validade do cartão expirada.');
      else if(val?.retornoCartao === 11 ) this.openMsg(false, 'Código segurança inválido.');
      else {
        EventEmitterService.get('refreshPainelFinanceiro').emit(true);
        this.router.navigate(['/pgto-ok']);
        //this.openMsg(true, 'Transação realizada com sucesso');
      }
    })
  }

  enviarLinkParaPagmento(option: number) {
    
  }
  
  openMsg(success, msg): void {
    const isMobileResolution = window.innerWidth < 768 ? true : false;

    const dialogRefMsg = this.dialog.open(MsgCompraComponent, {
      width: isMobileResolution ? '98vw' : '30vw',
      data: { success, msg },
      autoFocus: false
    });
    dialogRefMsg.afterClosed().subscribe(result => {
      if(result) this.dialogRef.close(true);
      else {
        const formArray: FormArray = this.form.get('cartoes') as FormArray;
        const formGroup: FormGroup = formArray.at(0) as FormGroup;
        formGroup.patchValue({
          valor: this.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
          parcela: 1,
          numero: null,
          nome: null,
          mes: null,
          ano: null,
          codigo: null
        });
      }
    });
  }

  getMatricula(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.matricula$ = this.storeAluno.pipe(select(AlunoStoreSelectors.selectMatriculaAluno)).subscribe(val => {
        if(val == undefined)  {
          this.matriculaId = Number(window.localStorage.getItem('matriculaIdLocalStorage'));
          resolve(val);
        }
        if(val?.id) {
          this.matriculaId = val?.id;
          resolve(val);
        } else reject();
      });
    });
  }

  async obterCobranca(): Promise<void> {
    ;
    this.animationsService.showProgressBar(true);
    try {
      const response = await this.consultarCobranca().toPromise();
        this.cobranca = response as DtoCobrancaPagamento;
        this.valorTotal = this.cobranca.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        this.opcoesParcelamento = this.validarOpcoesParcelamento(this.cobranca.valorTotal);
        this.usuarioId = this.cobranca.usuarioId;
        this.pagamentoIds = this.cobranca.pagamentoIds;
        this.matriculaId = this.cobranca.matriculaId;
        this.pagamentos = this.cobranca.pagamentos;
        this.tipoPagamento = this.cobranca.tipoPagamento;
        
      switch (this.tipoPagamento) {
        case 3:
          this.codigoPagamento = this.pagamentos.map(pagamento => pagamento.codigoBarras);
          this.tipoPgto = ' Boleto bancario';
          this.tipoCartao = true;
          this.tipoBoleto = true;
          this.tipoPix = true;
          this.codigoLinha = true;
          this.objCartao = false;
          this.isMobileScreen = true;
          break;
        case 8:
          this.codigoPagamento = this.pagamentos.map(pagamento => pagamento.codigoPix);
          this.tipoPgto = ' Pix';
          this.tipoCartao = true;
          this.tipoBoleto = true;
          this.tipoPix = true;
          this.codigoLinha = true;
          this.objCartao = false;
          this.isMobileScreen = true;
          break;
        default:
          this.objCartao = true;
          this.codigoLinha = false;
          this.codigoPagamento = [];
          this.tipoBoleto = false;
          this.tipoPix = false
          this.isMobileScreen = false;
          break;
      }
     
    } catch (error) {
      // Trate o erro de acordo com suas necessidades
      console.error('Falha ao obter a cobrança:', error);
    } finally {
      this.animationsService.showProgressBar(false);
    }
  }

  copyToClipboard(codigo: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = codigo;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    alert('Código copiado para a área de transferência!');
  }

  lerCodigo(tipo: number): void {
    switch (tipo) {
      case 3:
        this.codigoPagamento = this.pagamentos.map(pagamento => pagamento.codigoBarras);
        this.tipoPgto = 'Boleto bancario';
        this.codigoLinha = true;
        this.objCartao = false;
        this.isMobileScreen = true;
        this.tipoPagamento = 3;
        break;
      case 8:
        this.codigoPagamento = this.pagamentos.map(pagamento => pagamento.codigoPix);
        this.tipoPgto = 'Pix';
        this.codigoLinha = true;
        this.objCartao = false;
        this.isMobileScreen = true;
        this.tipoPagamento = 8;
        break;
      default:
        this.codigoLinha = false;
        this.objCartao = true;
        this.isMobileScreen = false;
        this.tipoPagamento = 1;
        break
    }
  }

  consultarCobranca(): Observable<DtoCobrancaPagamento> {
    const params: HttpParams = new HttpParams().set('token', this.token);
    return this.http.get<DtoCobrancaPagamento>(`${environment.baseUrl}${API.cobranca.consultarCobranca}`, { params })
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados de cobrança', []))
      );
  }


}

